import Vue from 'vue';
import bugsnag from '@bugsnag/js';
import bugsnagVue from '@bugsnag/plugin-vue';

const RELEASE_STAGES = {
  DEV: 'development',
  STAGING: 'staging',
  PROD: 'production',
};

// Shim for bugsnag client
// eslint-disable-next-line no-proto
setTimeout(() => {}).__proto__.unref = () => {};
const bugsnagClient = bugsnag({
  apiKey: 'b69e559ae29c3eea95e4e53ec17e48c9',
  appVersion: '1.7.0',
  releaseStage: RELEASE_STAGES.DEV,
});

bugsnagClient.use(bugsnagVue, Vue);

class Logger {
  // Note: This does not go to bugsnag
  // eslint-disable-next-line class-methods-use-this
  message(message) {
    // eslint-disable-next-line
    console.log(message);
  }

  info(message, error, meta, context) {
    bugsnagClient.notify(message, {
      severity: 'info',
      // eslint-disable-next-line no-underscore-dangle
      user: this._getUser(),
      context,
      metaData: {
        // eslint-disable-next-line no-mixed-operators
        error: error && error.response && error.response.data || error,
        // eslint-disable-next-line no-underscore-dangle
        ...this._getMeta(meta),
      },
    });
    // eslint-disable-next-line
    console.info(message, {error: error, meta: meta});
  }

  warn(message, error, meta, context) {
    bugsnagClient.notify(message, {
      severity: 'warning',
      // eslint-disable-next-line no-underscore-dangle
      user: this._getUser(),
      context,
      metaData: {
        // eslint-disable-next-line no-mixed-operators
        error: error && error.response && error.response.data || error,
        // eslint-disable-next-line no-underscore-dangle
        ...this._getMeta(meta),
      },
    });
    // eslint-disable-next-line
    console.warn(message, {error: error, meta: meta});
  }

  error(message, error, meta, context) {
    bugsnagClient.notify(message, {
      severity: 'error',
      // eslint-disable-next-line no-underscore-dangle
      user: this._getUser(),
      context,
      metaData: {
        // eslint-disable-next-line no-mixed-operators
        error: error && error.response && error.response.data || error,
        // eslint-disable-next-line no-underscore-dangle
        ...this._getMeta(meta),
      },
    });
    // eslint-disable-next-line
    console.error(message, {error: error, meta: meta});
  }

  // eslint-disable-next-line no-underscore-dangle,class-methods-use-this
  _getUser() {
    let user = null;
    if (localStorage.getItem('user')) {
      try {
        user = JSON.parse(localStorage.getItem('user'));
      } catch (err) {
        user = null;
      }
    }
    return user;
  }

  // eslint-disable-next-line no-underscore-dangle,class-methods-use-this
  _getMeta(meta) {
    if (!meta) {
      return {};
    }
    return meta;
  }
}

// eslint-disable-next-line import/prefer-default-export
export const logger = new Logger();
